import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-content-container',
  templateUrl: './content-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentContainerComponent {}
